import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, FileText, Mic, Radio } from 'lucide-react';
import { cn } from '../../../ui';
import DashCard, { CardEmpty, CardLink } from '../shared/DashCard';
import IconChip from '../shared/IconChip';
import { isUrgent, upcomingLink } from '../studentHomeRules';

const TYPE_LOOK = {
  assignment: { icon: FileText, tone: 'violet' },
  mock: { icon: Mic, tone: 'rose' },
  quiz: { icon: ClipboardCheck, tone: 'amber' },
  class: { icon: Radio, tone: 'sky' },
};

const UpcomingRow = ({ item }) => {
  const look = TYPE_LOOK[item.type] || TYPE_LOOK.assignment;
  return (
    <li>
      <Link
        to={upcomingLink(item)}
        className="tw-grid tw-grid-cols-[34px_minmax(0,1fr)] tw-items-center tw-gap-x-3 tw-rounded-md tw-px-2 tw-py-2 tw-text-content tw-no-underline tw-transition-colors hover:tw-bg-surface-sunken hover:tw-text-content tw-focus-ring-inset card-sm:tw-grid-cols-[34px_minmax(0,1fr)_auto]"
      >
        <IconChip icon={look.icon} tone={look.tone} className="tw-row-span-3 card-sm:tw-row-span-2" />
        <span className="tw-truncate tw-text-[0.8125rem] tw-font-semibold">{item.title}</span>
        <span className="tw-col-start-2 tw-truncate tw-text-[0.6875rem] tw-text-content-subtle">{item.subtitle}</span>
        <span
          className={cn(
            'tw-col-start-2 tw-mt-0.5 tw-text-[0.6875rem] tw-font-semibold card-sm:tw-col-start-3 card-sm:tw-row-span-2 card-sm:tw-row-start-1 card-sm:tw-mt-0 card-sm:tw-whitespace-nowrap',
            isUrgent(item) ? 'tw-text-danger-fg' : 'tw-text-content-muted',
          )}
        >
          {item.due}
        </span>
      </Link>
    </li>
  );
};

const UpcomingCard = ({ items, className }) => (
  <DashCard title="Upcoming" className={className} action={<CardLink to="/s/calendar">View calendar</CardLink>}>
    {items.length > 0 ? (
      <ul className="tw-m-0 tw--mx-2 tw-flex tw-list-none tw-flex-col tw-gap-1 tw-p-0">
        {items.map((item) => <UpcomingRow key={item.id} item={item} />)}
      </ul>
    ) : (
      <CardEmpty>Nothing scheduled. You&apos;re all caught up.</CardEmpty>
    )}
  </DashCard>
);

export default UpcomingCard;
